export default class Checkbox {
    constructor() {
        return {
            template: `
                  <label class="a-checkbox">
                     <input class="input"
                            type="checkbox" 
                            ng-checked="checkbox.ngModel"
                            ng-model="checkbox.ngModel"/>
                     <div class="bg"></div>
                  </label>
            `,
            bindings: {
                label: '@',
                ngModel: '='
            },
            controller: CheckboxCtrl,
            controllerAs: 'checkbox'
        }
    }
}

class CheckboxCtrl {
}
